import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { ToastService } from '../toast.service';
import { ToastComponent as SFToastComponent } from '@syncfusion/ej2-angular-notifications'
@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.less']
})
export class ToastComponent implements OnInit, AfterViewInit {

  @ViewChild('element')
  private toast!: SFToastComponent;


  
  constructor(private toastService: ToastService) { }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    this.toastService.setToast(this.toast);
  }

}
